<div *ngIf="isSettingLoaded" class="c-notifications-sidebar">
  <div class="c-notifications-sidebar__top-wrapper">
    <p500-ui-icon name="controls-close" (click)="close()" class="c-notifications-sidebar__close"></p500-ui-icon>

    <div class="c-notifications-sidebar__top">
      <h4 class="c-notifications-sidebar__title" i18n="@@common.notifications">Notifications</h4>
      <ng-container *rbac="RbacPermissionsConstant.WIDGETS_NOTIFICATIONS_SETTINGS">
        <a [routerLink]="'/app/settings/crm-notification-settings'" class="c-notifications-sidebar__settings-button">
          <p500-ui-icon name="settings"></p500-ui-icon>
        </a>
      </ng-container>
    </div>

    <ng-container *ngIf="banner">
      <gtd-banner [customClass]="'notifications-margin'" [banner]="banner" (onClose)="bannerClose()"></gtd-banner>
    </ng-container>

    <div class="c-notifications-sidebar__tabs">
      <ng-container *ngFor="let title of mainTabs">
        <button
          class="c-notifications-sidebar__button c-notifications-sidebar__tabs-button"
          [class.--active]="title === tabs.activeTabTitle"
          (click)="[(page = 1), (tabs.activeTabTitle = title), getNotificationsData()]"
        >
          <span class="c-notifications-sidebar__tabs-button__title">{{ title | notificationsTabsTitleTranslate }}</span>
        </button>
      </ng-container>
    </div>

    <div class="c-notifications-sidebar__sub-tabs">
      <div class="c-notifications-sidebar__sub-tabs-wrapper">
        <ng-container *ngFor="let title of subTabs | slice : 0 : 4">
          <button
            class="c-notifications-sidebar__button c-notifications-sidebar__sub-tabs-button"
            [class.--active]="title === activeSubTitle"
            (click)="[(page = 1), (tabs.activeSubTabTitle[tabs.activeTabTitle] = title), getNotificationsData()]"
          >
            <span class="c-notifications-sidebar__sub-tabs-button__title">{{ title | notificationsTabsTitleTranslate }}</span>
          </button>
        </ng-container>
      </div>

      <div class="more" [hidden]="subTabs.length < 4">
        <p500-ui-dropdown position="right" class="c-dropdown c-dropdown--list">
          <ng-template p500UIDropdownHeader let-isOpen="isOpen" let-toggle="toggle">
            <button (click)="toggle()" class="more__button" p500-ui-button>
              <p500-ui-icon name="other-menu"></p500-ui-icon>
            </button>
          </ng-template>
          <ng-template p500UIDropdownBody>
            <ng-container *ngFor="let title of subTabs | slice : 3">
              <div
                p500UIDropdownItem
                class="c-dropdown__item"
                (click)="[(page = 1), (tabs.activeSubTabTitle[tabs.activeTabTitle] = title), getNotificationsData()]"
              >
                <span class="c-dropdown__item-text">{{ title | notificationsTabsTitleTranslate }}</span>
              </div>
            </ng-container>
          </ng-template>
        </p500-ui-dropdown>
      </div>
    </div>
  </div>

  <ng-container *ngIf="notifications$ | async as notifications">
    <ul *ngIf="!isLoading && notifications?.length; else emptyTempl" class="c-notifications-sidebar__list">
      <ng-container *ngFor="let notification of notifications">
        <li class="c-notifications-sidebar__item" (click)="openNotificationsModal(notification)">
          <div class="c-notifications-sidebar__header">
            <span class="c-notifications-sidebar__id">ID:{{ notification.id }}</span>
            <span class="c-notifications-sidebar__info">
              <p500-ui-icon size="12px" name="information" class="mr-4"></p500-ui-icon>
              <ng-container i18n="@@common.view_info">View Info</ng-container>
            </span>
            <div class="c-notifications-sidebar__new">
              <gtd-ui-field-special-notification-type
                [data]="notification.type || notification?.status"
              ></gtd-ui-field-special-notification-type>
            </div>
          </div>
          <gtd-notification-description [data]="notification"></gtd-notification-description>
          <div class="c-notifications-sidebar__date">{{ notification.created_at_timestamp | timeAgo }}</div>
        </li>
      </ng-container>
    </ul>
  </ng-container>

  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>

  <div class="c-notifications-sidebar__bottom">
    <div class="c-notifications-sidebar__search">
      <gtd-table-search [ngModel]="null" (ngModelChange)="setFilterById($event)"></gtd-table-search>
    </div>
    <div class="c-notifications-sidebar__pagination">
      <p500-ui-pagination
        [totalItems]="totalItems"
        [itemsPerPage]="limit"
        [currentPage]="page"
        [limitOptions]="limitOptions"
        (currentPageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      >
      </p500-ui-pagination>
    </div>
  </div>
</div>

<ng-template #emptyTempl>
  <gtd-empty *ngIf="!isLoading" [noBorder]="true" icon="box" i18n-desc="@@common.data_wasnt_found" desc="Data wasn't found"></gtd-empty>
</ng-template>
